// Skeletons (DESIGN.md 10.7): shape-matching, no generic spinner.

export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="stack-sm" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton skel-row" />
      ))}
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="stack-sm" aria-hidden="true">
      <div className="skeleton skel-card" />
      <div className="skeleton skel-card" style={{ height: 80 }} />
    </div>
  );
}

export function LandingSkeleton() {
  return (
    <div
      className="section"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}
      aria-hidden="true"
    >
      <div className="skeleton" style={{ width: 32, height: 32, borderRadius: 8 }} />
      <div className="skeleton" style={{ width: 180, height: 20, borderRadius: 8 }} />
      <div className="skeleton" style={{ width: 240, height: 16, borderRadius: 8 }} />
    </div>
  );
}
